import { Box, IconButton, Tooltip, Typography, useTheme } from '@mui/material';
import { tokens } from '../../global/theme/tokens';

export const ECTopbar = ({
  children,
  label,
  sublabel,
  ActionIcon,
  actionTooltip,
  actionColor,
  onAction,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);

  return (
    <Box
      className="px-2 flex min-h-[45px] h-[45px] justify-between items-start"
      sx={{
        bgcolor: colors.card,
        '.actionButton': {
          transform: 'scale(0)',
          transition: '0.2s ease',
        },
        ':hover .actionButton': {
          transform: 'scale(1)',
        },
        // touch screens can't hover: always show the action
        '@media (hover: none)': {
          '.actionButton': { transform: 'scale(1)' },
        },
      }}
    >
      {label && (
        <Box className="flex flex-col">
          <Typography
            fontWeight={600}
            fontSize="15px"
            className="pt-[5px] pl-[2px]"
          >
            {label}
          </Typography>

          <Typography
            fontSize={11}
            fontWeight={500}
            className="opacity-50 pl-[2px]"
          >
            {sublabel}
          </Typography>
        </Box>
      )}
      {children}
      {onAction && ActionIcon && (
        <Tooltip title={actionTooltip} className="actionButton">
          <IconButton onClick={onAction} size="small">
            <ActionIcon color={actionColor} />
          </IconButton>
        </Tooltip>
      )}
    </Box>
  );
};
